// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CategoriesView_container__ZHrni {
  padding-top: 5rem;
  background-color: #1a1a1a;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 95%;
  margin: 0 auto;
}

.CategoriesView_header__oH-Qt {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 10px;
}

.CategoriesView_headerActions__45X\\+2 {
  display: flex;
  align-items: center;
  gap: 10px;
}

.CategoriesView_languageFilter__6TiLO {
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ddd;
  padding: 0 10px;
}

.CategoriesView_globeIcon__ziNFR {
  color: #666;
  width: 18px;
  height: 18px;
}

.CategoriesView_languageSelect__TmdST {
  border: none;
  padding: 10px;
  font-size: 14px;
  background: transparent;
  cursor: pointer;
  outline: none;
}

.CategoriesView_addButton__n6vn7 {
  display: flex;
  align-items: center;
  gap: 5px;
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.3s;
}

.CategoriesView_addButton__n6vn7:hover {
  background-color: #45a049;
}

.CategoriesView_searchBar__XdwMa {
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ddd;
  padding: 0 10px;
  flex: 1 1;
  max-width: 400px;
}

.CategoriesView_searchIcon__vLler {
  color: #666;
  width: 18px;
  height: 18px;
}

.CategoriesView_searchBar__XdwMa input {
  border: none;
  padding: 10px;
  width: 100%;
  font-size: 14px;
  outline: none;
}

.CategoriesView_categoriesList__nR63T {
  background-color: #1a1a1a;
  border-radius: 4px;
  border: 1px solid #ddd;
  overflow: hidden;
}

.CategoriesView_categoryItem__ShEiF {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}

.CategoriesView_categoryItem__ShEiF:last-child {
  border-bottom: none;
}

.CategoriesView_categoryInfo__VAbQn {
  display: flex;
  align-items: center;
  gap: 10px;
}

.CategoriesView_categoryName__SufKz {
  font-weight: 500;
  color: white;
}

.CategoriesView_categoryLanguage__WKDfL {
  font-size: 12px;
  background-color: #f0f0f0;
  padding: 2px 8px;
  border-radius: 10px;
  color: #666;
}

.CategoriesView_actions__11aL7 {
  display: flex;
  gap: 8px;
}

.CategoriesView_iconButton__QUQvJ {
  background: none;
  border: none;
  cursor: pointer;
  color: #666;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.CategoriesView_iconButton__QUQvJ:hover {
  background-color: #f0f0f0;
}

.CategoriesView_noCategories__f96wq {
  padding: 20px;
  text-align: center;
  color: #666;
}

.CategoriesView_modalOverlay__-xHR7 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.CategoriesView_modal__KrYi- {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.CategoriesView_modal__KrYi- h2 {
  margin-top: 0;
  margin-bottom: 16px;
}

.CategoriesView_formGroup__59D\\+r {
  margin-bottom: 15px;
}

.CategoriesView_formGroup__59D\\+r label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}

.CategoriesView_modalInput__HC3KI,
.CategoriesView_modalSelect__W4MTl {
  width: 100%;
  padding: 10px;
  margin-bottom: 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.CategoriesView_modalButtons__wkItv {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.CategoriesView_cancelButton__YBEv0 {
  background-color: #f0f0f0;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
}

.CategoriesView_deleteButton__n-fos {
  background-color: #f44336;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
}

.CategoriesView_loading__gXSwC {
  display: flex;
  justify-content: center;
  padding: 50px 0;
}

.CategoriesView_error__z6pn1 {
  color: #f44336;
  text-align: center;
  padding: 20px;
}

@media (max-width: 768px) {
  .CategoriesView_header__oH-Qt {
    flex-direction: column;
    align-items: stretch;
  }
  
  .CategoriesView_searchBar__XdwMa {
    max-width: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/admin/pages/content/components/CategoriesView.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".container {\n  padding-top: 5rem;\n  background-color: #1a1a1a;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  max-width: 95%;\n  margin: 0 auto;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.headerActions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.languageFilter {\n  display: flex;\n  align-items: center;\n  background-color: #fff;\n  border-radius: 4px;\n  border: 1px solid #ddd;\n  padding: 0 10px;\n}\n\n.globeIcon {\n  color: #666;\n  width: 18px;\n  height: 18px;\n}\n\n.languageSelect {\n  border: none;\n  padding: 10px;\n  font-size: 14px;\n  background: transparent;\n  cursor: pointer;\n  outline: none;\n}\n\n.addButton {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.3s;\n}\n\n.addButton:hover {\n  background-color: #45a049;\n}\n\n.searchBar {\n  display: flex;\n  align-items: center;\n  background-color: #fff;\n  border-radius: 4px;\n  border: 1px solid #ddd;\n  padding: 0 10px;\n  flex: 1;\n  max-width: 400px;\n}\n\n.searchIcon {\n  color: #666;\n  width: 18px;\n  height: 18px;\n}\n\n.searchBar input {\n  border: none;\n  padding: 10px;\n  width: 100%;\n  font-size: 14px;\n  outline: none;\n}\n\n.categoriesList {\n  background-color: #1a1a1a;\n  border-radius: 4px;\n  border: 1px solid #ddd;\n  overflow: hidden;\n}\n\n.categoryItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  border-bottom: 1px solid #eee;\n}\n\n.categoryItem:last-child {\n  border-bottom: none;\n}\n\n.categoryInfo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.categoryName {\n  font-weight: 500;\n  color: white;\n}\n\n.categoryLanguage {\n  font-size: 12px;\n  background-color: #f0f0f0;\n  padding: 2px 8px;\n  border-radius: 10px;\n  color: #666;\n}\n\n.actions {\n  display: flex;\n  gap: 8px;\n}\n\n.iconButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #666;\n  padding: 4px;\n  border-radius: 4px;\n  transition: background-color 0.3s;\n}\n\n.iconButton:hover {\n  background-color: #f0f0f0;\n}\n\n.noCategories {\n  padding: 20px;\n  text-align: center;\n  color: #666;\n}\n\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal {\n  background-color: #fff;\n  border-radius: 8px;\n  padding: 20px;\n  width: 90%;\n  max-width: 400px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.modal h2 {\n  margin-top: 0;\n  margin-bottom: 16px;\n}\n\n.formGroup {\n  margin-bottom: 15px;\n}\n\n.formGroup label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: 500;\n}\n\n.modalInput,\n.modalSelect {\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 16px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.modalButtons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.cancelButton {\n  background-color: #f0f0f0;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.deleteButton {\n  background-color: #f44336;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  padding: 50px 0;\n}\n\n.error {\n  color: #f44336;\n  text-align: center;\n  padding: 20px;\n}\n\n@media (max-width: 768px) {\n  .header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .searchBar {\n    max-width: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CategoriesView_container__ZHrni`,
	"header": `CategoriesView_header__oH-Qt`,
	"headerActions": `CategoriesView_headerActions__45X+2`,
	"languageFilter": `CategoriesView_languageFilter__6TiLO`,
	"globeIcon": `CategoriesView_globeIcon__ziNFR`,
	"languageSelect": `CategoriesView_languageSelect__TmdST`,
	"addButton": `CategoriesView_addButton__n6vn7`,
	"searchBar": `CategoriesView_searchBar__XdwMa`,
	"searchIcon": `CategoriesView_searchIcon__vLler`,
	"categoriesList": `CategoriesView_categoriesList__nR63T`,
	"categoryItem": `CategoriesView_categoryItem__ShEiF`,
	"categoryInfo": `CategoriesView_categoryInfo__VAbQn`,
	"categoryName": `CategoriesView_categoryName__SufKz`,
	"categoryLanguage": `CategoriesView_categoryLanguage__WKDfL`,
	"actions": `CategoriesView_actions__11aL7`,
	"iconButton": `CategoriesView_iconButton__QUQvJ`,
	"noCategories": `CategoriesView_noCategories__f96wq`,
	"modalOverlay": `CategoriesView_modalOverlay__-xHR7`,
	"modal": `CategoriesView_modal__KrYi-`,
	"formGroup": `CategoriesView_formGroup__59D+r`,
	"modalInput": `CategoriesView_modalInput__HC3KI`,
	"modalSelect": `CategoriesView_modalSelect__W4MTl`,
	"modalButtons": `CategoriesView_modalButtons__wkItv`,
	"cancelButton": `CategoriesView_cancelButton__YBEv0`,
	"deleteButton": `CategoriesView_deleteButton__n-fos`,
	"loading": `CategoriesView_loading__gXSwC`,
	"error": `CategoriesView_error__z6pn1`
};
export default ___CSS_LOADER_EXPORT___;
